import request from '@/utils/request'

/**
 * 企业项目类型
 */
export function getCorpTypes(query) {
  return request({
    url: '/corp-type',
    method: 'get',
    params: query
  })
}

export function getCorpType(id) {
  return request({
    url: `/corp-type/${id}`,
    method: 'get'
  })
}

export function deleteCorpType(id) {
  return request({
    url: `/corp-type/${id}`,
    method: 'delete'
  })
}

export function addCorpType(data) {
  return request({
    url: '/corp-type',
    method: 'post',
    data
  })
}

export function updateCorpType(id, data) {
  return request({
    url: `/corp-type/${id}`,
    method: 'put',
    data
  })
}

export function getCorpTypeOptions() {
  return request({
    url: '/corp-type/name-options',
    method: 'get'
  })
}

/**
 * 企业项目管理
 */

export function getCorps(query) {
  return request({
    url: '/corp',
    method: 'get',
    params: query
  })
}

export function addCorp(data) {
  return request({
    url: '/corp',
    method: 'post',
    data
  })
}

export function updateCorp(id, data) {
  return request({
    url: `/corp/${id}`,
    method: 'put',
    data
  })
}

export function getCorp(id) {
  return request({
    url: `/corp/${id}`,
    method: 'get'
  })
}

export function deleteCorps(ids) {
  return request({
    url: `/corp/${ids}`,
    method: 'delete'
  })
}

export function getCorpOptions() {
  return request({
    url: '/corp/name-options',
    method: 'get'
  })
}

export function getIotGwOptions() {
  return request({
    url: '/corp/iot-gw-options',
    method: 'get'
  })
}

export function getBliveGwOptions() {
  return request({
    url: '/corp/blive-gw-options',
    method: 'get'
  })
}

export function repairTable(data) {
  return request({
    url: '/corp/repair-table',
    method: 'post',
    data
  })
}
